<div
  class="enfaf-input-single-file-dragger-dark"
  [class.dragover]="isDraggingOver"
  [style.--single-file-height]="height"
  (dragover)="onDragOver($event)"
  (dragleave)="onDragLeave($event)"
  (drop)="onDrop($event)"
>
  <div
    class="dropzone-area"
    [class.dropzone-area--has-preview]="hasVisualPreview"
    [class.dropzone-area--disabled]="disabled"
    [class.dropzone-area--default]="state === 'default'"
    [class.dropzone-area--error]="state === 'error'"
    [class.dropzone-area--success]="state === 'success'"
    [class.dropzone-area--with-file-name]="showFileName"
    [class.dropzone-area--has-file]="hasSelectedFile"
    [style.min-height]="height"
    (click)="!disabled && !isPreviewLoading && (hasSelectedFile ? onPreviewClick($event) : triggerFileInput())"
  >
    @if (isPreviewLoading) {
      <div class="loader-overlay" role="status" aria-label="Cargando documento">
        <app-progress [size]="40" [showCheckIcon]="false" [showPercentage]="false" color="#FFFFFF"></app-progress>
      </div>
    } @else if (showActionOverlay) {
      <div class="action-buttons" aria-label="Acciones del documento" (click)="$event.stopPropagation()">
        <button type="button" class="action-button action-button--edit" aria-label="Editar archivo" (click)="onEditClick($event)">
          <app-enfaf-icon svgIconName="edit" iconSize="24px"></app-enfaf-icon>
        </button>
        <button type="button" class="action-button action-button--delete" aria-label="Eliminar archivo" (click)="onRemoveClick($event)">
          <app-enfaf-icon svgIconName="trash" iconSize="24px"></app-enfaf-icon>
        </button>
      </div>
    } @else if (hasSelectedFile && !disabled && !activeMode) {
      <div class="remove-button" aria-label="Eliminar archivo" (click)="onRemoveClick($event)">
        <app-enfaf-icon svgIconName="trash-red" iconSize="21px"></app-enfaf-icon>
      </div>
    }

    @if (!isPreviewLoading) {
      @if (hasSelectedFile) {
        <div class="preview-area">
          @if (isImagePreview && previewImageUrl) {
            <img [src]="previewImageUrl" alt="Vista previa del archivo" class="preview-image" />
          } @else if (isPdfPreview && previewPdfUrl) {
            <img [src]="previewPdfUrl" alt="Vista previa del PDF" class="preview-pdf" />
          } @else {
            <div class="file-placeholder">
              <app-enfaf-icon class="file-placeholder__icon" svgIconName="file-dark" iconSize="56px" color="#FFFFFF"></app-enfaf-icon>
              <span class="file-placeholder__extension">{{ selectedFileExtension }}</span>
              <span class="file-placeholder__name" [title]="selectedFileName">{{ selectedFileName }}</span>
              <span class="file-placeholder__hint">Haz clic para ver</span>
            </div>
          }
        </div>

        @if (showFileName) {
          <div class="file-name-bar" aria-label="Nombre del archivo">
            <span class="file-name-bar__label">{{ selectedFileName }}</span>
          </div>
        }
      } @else {
        <div class="content">
          <div class="content-header">
            <app-enfaf-icon class="upload-cloud" svgIconName="upload-cloud-white" iconSize="56px" color="#FFFFFF"></app-enfaf-icon>
            <div class="text">
              {{ title }}
              <br />
              {{ subtitle }}
            </div>
          </div>
          <app-enfaf-button class="upload-button" type="dark-blue" height="41px" [setNgStyle]="{ 'font-size': '14px', 'max-height': '41px' }">
            {{ buttonText }}
          </app-enfaf-button>
        </div>
      }
    }
  </div>
</div>

<input
  #fileInput
  type="file"
  class="hidden-file-input"
  title="Seleccionar archivo"
  [accept]="accept"
  [disabled]="disabled || uploadDisabled"
  (change)="onFileSelected($event)"
/>
